var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"},on:{"click":function($event){$event.stopPropagation();return _vm.hide.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.error.message || "")+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }